"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTimeout;
function getTimeout() {
  let start_time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let MIN_REQ_TIME = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
  const time_to_req = new Date() - start_time;
  let timeout_duration = 0;
  if (time_to_req <= 0 || isNaN(time_to_req)) {
    timeout_duration = 0;
  } else if (time_to_req >= MIN_REQ_TIME) {
    timeout_duration = 0;
  } else {
    timeout_duration = MIN_REQ_TIME - time_to_req;
  }
  return timeout_duration;
}
